module.exports = "https://static.wanderu.com/ui-react/_next/static/media/usa-today.9f25b034.png";